import { getPortalToken, clearPortalSession, PORTAL_LOGIN_PATH } from "./auth";
import { getApiBase, portalApiUrl } from "./portalApiBase";

export { getApiBase, API_BASE, portalApiUrl } from "./portalApiBase";

export async function api(path, options = {}) {
  const { ...fetchOptions } = options;
  const token = getPortalToken();
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
    ...(fetchOptions.headers || {}),
  };
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(portalApiUrl(path), {
    credentials: "include",
    ...fetchOptions,
    headers,
  });

  if (
    res.status === 401 &&
    typeof window !== "undefined" &&
    window.location.pathname.startsWith("/naturals-portal/") &&
    window.location.pathname !== "/naturals-portal"
  ) {
    clearPortalSession();
    window.location.assign(PORTAL_LOGIN_PATH);
  }

  return res;
}

export async function apiJson(path, options = {}) {
  const res = await api(path, options);
  const contentType = (res.headers.get("content-type") || "").toLowerCase();
  if (!contentType.includes("application/json")) {
    const hint =
      "Portal API returned HTML — check nyafaz-naturals-portal (5125) and nginx /naturals-portal-api/";
    throw new Error(res.ok ? hint : `Portal API error (${res.status}). ${hint}`);
  }
  const data = await res.json();
  return { res, data };
}
